module.exports = __webpack_public_path__ + "img/form-result-success.svg";